var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoteHist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.2H9V11H3V12.2ZM3 9H9V7.8H3V9ZM1.4462 15.2C1.04207 15.2 0.7 15.06 0.42 14.78C0.14 14.5 0 14.1579 0 13.7538V1.4462C0 1.04207 0.14 0.7 0.42 0.42C0.7 0.14 1.04207 0 1.4462 0H7.8L12 4.2V13.7538C12 14.1579 11.86 14.5 11.58 14.78C11.3 15.06 10.9579 15.2 10.5538 15.2H1.4462ZM7.2 4.8V1.2H1.4462C1.3846 1.2 1.3282 1.22567 1.277 1.277C1.22567 1.3282 1.2 1.3846 1.2 1.4462V13.7538C1.2 13.8154 1.22567 13.8718 1.277 13.923C1.3282 13.9743 1.3846 14 1.4462 14H10.5538C10.6154 14 10.6718 13.9743 10.723 13.923C10.7743 13.8718 10.8 13.8154 10.8 13.7538V4.8H7.2Z",
    fill: "#323848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteHist);
export default __webpack_public_path__ + "static/media/note_hist.cafd08ad489efded479a03b8d7ae185b.svg";
export { ForwardRef as ReactComponent };